import { useState, useEffect } from 'react';
import './Nav.scss';
import signature from '../assets/signature.png';
import signatureB from '../assets/signatureB.png';
import cvFile from '../assets/curriculum-vitae-fabien-bazire.pdf';

const Nav = ({ alwaysVisible = false }) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const active = alwaysVisible || scrolled;
  const close = () => setMenuOpen(false);

  return (
    <>
      <nav className={`nav${active ? ' nav--scrolled' : ''}${menuOpen ? ' nav--open' : ''}`}>
        <a href="/" className="nav__logo">
          <img src={active || menuOpen ? signatureB : signature} alt="Fabien Bazire" />
        </a>

        <ul className="nav__links">
          <li><a href="/#works">Mon Travail</a></li>
          <li><a href="/#about">Me Connaître</a></li>
          <li><a href="/#approach">Mon Approche</a></li>
          <li><a href="/#contact" className="nav__cta">Contact</a></li>
          <li>
            <a href={cvFile} download="CV-Fabien-Bazire.pdf" className="nav__cv" title="Télécharger mon CV">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="12" y1="12" x2="12" y2="18" />
                <polyline points="9 15 12 18 15 15" />
              </svg>
              CV
            </a>
          </li>
        </ul>

        <button
          className={`nav__burger${menuOpen ? ' nav__burger--open' : ''}`}
          onClick={() => setMenuOpen(o => !o)}
          aria-label="Menu"
        >
          <span /><span /><span />
        </button>
      </nav>

      <div className={`nav__menu${menuOpen ? ' nav__menu--open' : ''}`}>
        <ul className="nav__menu-links">
          <li><a href="/#works" onClick={close}>Mon Travail</a></li>
          <li><a href="/#about" onClick={close}>Me Connaître</a></li>
          <li><a href="/#approach" onClick={close}>Mon Approche</a></li>
          <li><a href="/#contact" onClick={close}>Contact</a></li>
        </ul>
        <a href={cvFile} download="CV-Fabien-Bazire.pdf" className="nav__menu-cv" onClick={close}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="12" y1="12" x2="12" y2="18" />
            <polyline points="9 15 12 18 15 15" />
          </svg>
          Télécharger mon CV
        </a>
      </div>
    </>
  );
};

export default Nav;
